import BoatPage from "./BoatPage";
import { IMG } from "../../i18n/marketingImages";

export default function Greenline39() {
  return <BoatPage boatKey="gl39" image={IMG.gl39} testidBase="boat-39" />;
}
